import styled, { css } from 'styled-components';
import { getColor } from 'core/utils';
import { default as IconClose } from 'core/icons/Close';

export const Wrapper = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;

	/* Sorry not sorry, lol */
	z-index: 999999999;
	width: 100%;
	height: 100%;
	background: ${getColor('white')};
	pointer-events: none;
	opacity: 0;
	transition: opacity 0.2s;

	@media (min-width: 768px) {
		display: none;
		pointer-events: none;
		opacity: 0;
	}
`;

export const Flex = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const Body = styled.div`
	padding: 0 36px 43px;
	flex: 2;
	overflow-y: auto;
`;

export const HiddenCheck = styled.input.attrs({
	type: 'checkbox'
})`
	display: none;

	&:checked ~ ${Wrapper} {
		opacity: 1;
		pointer-events: all;

		@media (min-width: 768px) {
			display: none;
			pointer-events: none;
		}
	}
`;

export const Header = styled.header`
	flex: 0;
	padding: 30px;
	display: flex;
	align-items: center;

	${props => props.showBorder && css`
		border-bottom: 1px solid ${getColor('alto')};
		margin-bottom: 24px;
	`}
`;

// This accounts for the 40px area the Close button occupies
// add these styles to the element passed to `header` prop
export const centeredTitle = css`
	flex: 1;
	margin: 0 -40px 0 40px;
	padding-right: 40px;
	text-align: center;
`;

export const Footer = styled.footer`
	flex: 0;
	padding: 20px 28px;
	box-shadow: 0 -20px 35px 0 rgba(74,74,74,0.08);

	${props => props.darkFooter && css`
		color: ${getColor('white')};
		background-color: ${getColor('gray')};
	`}
`;

export const Close = styled.label`
	padding: 10px;

	/* Hacks so the X is aligned but the whole area is 40px */
	margin: -10px -10px 0 auto;
	display: block;
	width: 40px;
	height: 40px;
	cursor: pointer;

	svg {
		display: block;
	}
`;

export const CloseIcon = styled(IconClose)`
	fill: ${getColor('dustyGray')};
	stroke: ${getColor('white')};
	width: 21px;
	height: 21px;
`;

export const TriggerLabel = styled.label`
	margin: ${(props) => props.largeTrigger ? `0 10px 0 -10px` : `0 20px 0 0`};
	padding: ${(props) => props.largeTrigger ? `0 10px` : `0`};
	display: flex;
	align-items: center;
	cursor: pointer;
`;
